import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import Button from 'js/components/shared/Button';
import PopupRedesign from 'js/components/PopupRedesign'

import styles from './ModuleDropdown.module.scss'

const cx = classnames.bind(styles);

const ModuleDropdown = function ({
  className,
  children,
  title,
  onClose,
  formId,
  submitTxt = 'Apply',
  submitDisabled = false,
  autoFocus = true,
  onSubmit
}) {
  const onModalClose = function () {
    onClose && onClose()
  }

  return (
    <PopupRedesign
      className={cx('root', className)}
      onClose={onModalClose}
      useScrollBack={false}
      closeClassName={cx('modal-close')}
      bodyClassName={cx('modal-body')}
      autoFocus={autoFocus}
      theme="mobile-full"
    >
      <div className={cx('head')}>
        {title && (<h3 className={cx('title')}>{title}</h3>)}
      </div>
      <div className={cx('body')}>{children}</div>
      {(onSubmit || formId) && (
        <div className={cx('footer')}>
          <Button
            type="submit"
            size="lg"
            theme="squared"
            className={cx('submit')}
            disabled={submitDisabled}
            form={formId}
            onClick={onSubmit}
          >
            {submitTxt}
          </Button>
        </div>
      )}
    </PopupRedesign>
  )
}

ModuleDropdown.propTypes = {
  data: PropTypes.any,
  title: PropTypes.string,
  onClose: PropTypes.func,
  formId: PropTypes.string,
  children: PropTypes.node,
  submitTxt: PropTypes.string,
  onSubmit: PropTypes.func,
  submitDisabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
}

export default ModuleDropdown;
